import { render, staticRenderFns } from "./THGTagChip.vue?vue&type=template&id=094e34e0"
import script from "./THGTagChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTagChip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports